import img1 from "../img/prod3.png"
import img2 from "../img/prod2.png"
import img3 from "../img/prod1.png"
import "../css/ProductsSection.css"

const ProductsSection = () => {
  return (
    <section className="products-section">
      <div className="products-container">
        <h2 className="products-title">REPUESTOS</h2>
        <div className="products-grid">
          <div className="product-card">
            <div className="product-image">
              <img src={img1 || "/placeholder.svg"} alt="Repuestos Automotrices" />
            </div>
            <div className="product-content">
              <h3 className="product-title">Repuestos Automotrices</h3>
              <p className="product-description">
                Repuestos automotrices de marcas de primer nivel, que cumplen estándares de Equipo Original.
              </p>
            </div>
          </div>
          <div className="product-card">
            <div className="product-image">
              <img src={img2 || "/placeholder.svg"} alt="Repuestos Industriales" />
            </div>
            <div className="product-content">
              <h3 className="product-title">Repuestos Industriales</h3>
              <p className="product-description">
                La eficiencia premium que ofrecen las líneas de nuestros repuestos industriales optimiza el bajo consumo
                de energía y más.
              </p>
            </div>
          </div>
          <div className="product-card">
            <div className="product-image">
              <img src={img3 || "/placeholder.svg"} alt="Aceros" />
            </div>
            <div className="product-content">
              <h3 className="product-title">Aceros</h3>
              <p className="product-description">
                Fabricamos diferentes productos de acero inoxidable y otros metales de marcas de prestigio.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductsSection
